import { PuckPage } from "src/api/client-api/cms/useCreatePuckPage";

/**
 * @abstract
 * This utils file is used to categorize pages into 2 categories:
 * - Homepage
 * - Regular pages
 *
 * This is temporary, we will have a better categorization system in the future
 * backend side
 *
 * Reserved slugs
 * Homepage: home
 */
//

const SPECIAL_PAGE_TYPES = {
    HOME: "home",
};

export const isPageOfType = (slug: string, pageType: string): boolean => slug.toLowerCase() === pageType.toLowerCase();

export const isHomePage = (slug: string): boolean => isPageOfType(slug, SPECIAL_PAGE_TYPES.HOME);

export const isRegularPage = (slug: string): boolean =>
    !Object.values(SPECIAL_PAGE_TYPES).some((type) => isPageOfType(slug, type));

export const categorizePages = (
    pages: PuckPage[],
): {
    homePage: PuckPage[];
    regularPages: PuckPage[];
} => {
    const homePage = pages?.filter((page) => isHomePage(page.slug)) || [];
    const regularPages = pages?.filter((page) => isRegularPage(page.slug)) || [];

    return {
        homePage,
        regularPages,
    };
};
